import React, { useState, useEffect } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { Currency } from "./helper";
import downloadCsv from 'download-csv';
import Tooltips from "../components/Common/Tooltip";
import { ChevronsLeft, ChevronLeft, ChevronRight, ChevronsRight, Download, Search, RotateCw } from "lucide-react";
import { Button } from "../ui/button";
import ColumnManager from "../components/Common/table/ColumnManager";
import { useColumnPreferences } from "./hooks/useColumnPreferences";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Input } from "../ui/input";
import { Checkbox } from "../ui/checkbox";
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
} from "../ui/pagination";

function downlaodCsvFile(rawHeaders, rawData, fileName) {
  let headers = {};
  rawHeaders.forEach(key => { headers = { ...headers, [key]: key }; });
  const bodyData = rawData.map(item => {
    let itemObject = {};
    for (let key in item) { itemObject = { ...itemObject, [rawHeaders[key]]: item[key] }; }
    return itemObject;
  });
  downloadCsv(bodyData, headers, fileName);
}

const Vpagination = (props) => {
  const { hideDocs, enableAll, reportsLoader, allRecordsData, searchIniMount, searchHandler = () => { }, onclickSearch = () => { }, disableButton, isSearchClicked = false, handlerSyndicate = () => { }, focusAction = () => { }, showSubAffiliate, isChecked, onCheckboxChange, downloadAllLoader = false, tableData, storageKey, scrollKey, columns, onToggle, onReorder, onReset } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  // Manage-columns control lives here (in the toolbar) rather than floating over the
  // table itself. Column state can arrive two ways:
  //  - caller-owned: the page already calls useColumnPreferences for its table and
  //    passes columns/onToggle/onReorder/onReset straight through
  //  - toolbar-owned: the page passes `tableData` (headers in row 0) and this shares
  //    a storageKey with the Table rendering it, so both stay in sync
  const columnHeaders = Array.isArray(tableData) ? tableData[0] || [] : [];
  const ownPrefs = useColumnPreferences(
    storageKey || scrollKey || location.pathname,
    columnHeaders
  );
  const isCallerOwned = Array.isArray(columns);
  const allColumns = isCallerOwned ? columns : ownPrefs.allColumns;
  const toggleVisibility = isCallerOwned ? onToggle : ownPrefs.toggleVisibility;
  const reorder = isCallerOwned ? onReorder : ownPrefs.reorder;
  const resetToDefault = isCallerOwned ? onReset : ownPrefs.resetToDefault;
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [documentType, setDocumentType] = useState("PDF");
  const [csvData, setCsvData] = useState([]);
  // const [processRegulator, setProcessRegulator] = useState(true);
  const [masking, setMasking] = useState(false)
  const [searchData, setSearchData] = useState("");
  // const location = useLocation();
  // const reportsLoader = useSelector(st => st.paymentSearchSlice.reportsLoader);
  // const reportDocs = useSelector(st => st.paymentSearchSlice.reportDocs);
  const handlePageChange = (pageNumber) => {
    dispatch(props.setIsVisible(false));
    dispatch(props.setPaginationFirstValue(pageNumber));
    props.callApi(
      pageNumber,
      props.paginationSecondValue,
      props.payloadData && props.payloadData
    );
    recordsShow(pageNumber, props.paginationSecondValue);
    props.resetCsvData && props.resetCsvData();
  };

  const recordsShow = (pageNumber, itemsPerPage) => {
    const itemsperpage = Number(itemsPerPage);
    var recordsFrom = "";
    var recordsTo = "";
    if (pageNumber === 1) {
      if (props.totalRecords < pageNumber * itemsperpage) {
        recordsTo = props.totalRecords - 1;
      }
    }
    if (pageNumber == 0) {
      recordsFrom = 1;
      recordsTo = itemsPerPage;
    } else {
      recordsFrom = itemsPerPage * (pageNumber - 1) + 1;
      recordsFrom = itemsPerPage * (pageNumber - 1) + 1;
      if (props.totalRecords < pageNumber * itemsPerPage) {
        recordsTo = props.totalRecords;
      } else {
        recordsTo = itemsPerPage * pageNumber;
      }
    }
    dispatch(props.setRecordsShow([recordsFrom, recordsTo]));
  };

  const onChangeItemperpage = (e) => {
    const value = Number(e.target.value);
    setItemsPerPage(value);
    dispatch(props.setPaginationSecondValue(value));
    dispatch(props.setIsVisible(false));
    if (props.totalRecords < props.paginationFirstValue * value) {
      dispatch(props.setPaginationFirstValue(1));
      props.callApi(1, value, props.payloadData);
      recordsShow(1, value);
    } else {
      props.callApi(props.paginationFirstValue, value, props.payloadData);
      recordsShow(props.paginationFirstValue, value);
    }
    props.resetCsvData && props.resetCsvData();
  };

  const reloadPage = () => {
    props.callApi(props.paginationFirstValue, props.paginationSecondValue);
    recordsShow(props.paginationFirstValue, props.paginationSecondValue);
  };


  var pagenum =
    props.totalRecords != undefined
      ? props.totalRecords / props.paginationSecondValue
      : 0;
  var pageValue = Math.ceil(pagenum);
  const pageFirstVal =
    props.totalRecords == 0 &&
      props.data &&
      Object.keys(props.data).length > 0 &&
      props.data.length > 0
      ? 0
      : props.recordsShow?.length > 0 ? props.recordsShow[0] : {};

  const pageSecondVal =
    props.data != undefined &&
      props.data &&
      Object.keys(props.data).length > 0 &&
      props.data.length > 0 &&
      props.totalRecords >
      props.paginationFirstValue * props.paginationSecondValue
      ? props.paginationFirstValue * props.paginationSecondValue
      : props.totalRecords;
  const firstRecord =
    props.data && Object.keys(props.data).length > 0 && props.data.length > 0
      ? pageFirstVal
      : 0;

  const secondRecord =
    props.data && Object.keys(props.data).length > 0 && props.data.length > 0
      ? pageSecondVal
      : 0;
  const TotalRecords =
    props.data && Object.keys(props.data).length > 0 && props.data.length > 0
      ? props.totalRecords
      : 0;
  const isVisible = props.isVisible;

  const pageResultsStyle = {
    // minWidth: "0px",
    textAlign: "right",
  };
  useEffect(() => {
    setCsvData(props.csvData);
    if (localStorage.getItem("isMasking") === "DATA_MASKING") {
      setMasking(true)
    } else {
      setMasking(false)
    }
  }, [props.csvData]);

  const handleSearch = (value) => {
    setSearchData(value);
    if (!isSearchClicked) {
      props.onDataSearch(value);
    }
  }

  const onFocus = () => {
    focusAction()
  }

  const docsDownloadHandler = (allRecords) => {
    if (documentType === "PDF") {
      props.exportPDF(allRecords);
    } else {
      const headers = props.csvData[0];
      const bodyData = allRecords ? allRecordsData.csv : props.csvData;
      const body = bodyData.slice(1, bodyData.length);
      const fileName = `${props.csvFileName}.csv`;

      downlaodCsvFile(headers, body, fileName);
    }
  }

  const downloadAllDocsHandler = () => {
    if (downloadAllLoader) {
      return; // Prevent duplicate calls when already loading
    }
    props.callAllDownloadApi(
      1,
      TotalRecords,
      props.payloadData || {}
    );
  }

  useEffect(() => {
    let mounting = true;
    if (mounting) {
      let dataExist = allRecordsData && Array.isArray(allRecordsData.csv) && allRecordsData.csv.length > 0
      if (dataExist) {
        docsDownloadHandler(true);
      }
    }

    return () => mounting = false;
  }, [allRecordsData]);

  // useEffect(() => {
  //   let mounting = true;

  //   if (mounting) {
  //     dispatch(props.setPaginationFirstValue(1))
  //     dispatch(props.setPaginationSecondValue(25));
  //     setDocumentType("PDF");
  //   }
  //   return () => mounting = false;

  // }, [location.pathname])


  function handleClickSearch() {
    onclickSearch(searchData)
  }

  if (!props.data || props.data.length === 0) {
    return null;
  }

  const renderPaginationItems = () => {
    const items = [];
    const maxVisiblePages = 3;

    if (pageValue <= maxVisiblePages) {
      for (let i = 1; i <= pageValue; i++) {
        items.push(
          <PaginationItem key={i}>
            <PaginationLink
              onClick={() => handlePageChange(i)}
              isActive={props.paginationFirstValue === i}
              className="cursor-pointer"
            >
              {i}
            </PaginationLink>
          </PaginationItem>
        );
      }
    } else {
      // Calculate which 3 pages to show
      let start = Math.max(1, props.paginationFirstValue - 1);
      let end = Math.min(pageValue, start + 2);

      // Adjust if we're near the end
      if (end === pageValue) {
        start = Math.max(1, end - 2);
      }

      // Show ellipsis before if not starting at page 1
      if (start > 1) {
        items.push(<PaginationEllipsis key="ellipsis-start" />);
      }

      // Show the 3 pages
      for (let i = start; i <= end; i++) {
        items.push(
          <PaginationItem key={i}>
            <PaginationLink
              onClick={() => handlePageChange(i)}
              isActive={props.paginationFirstValue === i}
              className="cursor-pointer"
            >
              {i}
            </PaginationLink>
          </PaginationItem>
        );
      }

      // Show ellipsis after if not ending at last page
      if (end < pageValue) {
        items.push(<PaginationEllipsis key="ellipsis-end" />);
      }
    }

    return items;
  };


  return (
    <>
      <div className='space-y-3 bg-card p-4 rounded-lg border'>
        {/* First Row - Search & Filters */}
        {(showSubAffiliate || props.isSearch) && (
          <div className='flex items-center justify-between gap-4'>
            {/* Sub Affiliate Checkbox */}
            {showSubAffiliate && (
              <div className='flex items-center gap-2'>
                <Checkbox
                  id='checkboxAff'
                  checked={isChecked}
                  onCheckedChange={onCheckboxChange}
                />
                <label
                  htmlFor='checkboxAff'
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
                >
                  Include Sub Affiliate
                </label>
              </div>
            )}

            {/* Search Section */}
            {props.isSearch && (
              <div className="flex items-center gap-2 ml-auto">
                <div className="relative">
                  <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                  <Input
                    type="text"
                    placeholder={props.placeholder}
                    id="myInput"
                    name="searchData"
                    value={searchData}
                    onChange={(e) => handleSearch(e.target.value)}
                    onFocus={() => onFocus()}
                    className="!w-64 !h-9 pl-9"
                  />
                </div>
                {/* isSearchClicked callers defer the actual search to this button
                    (e.g. it triggers a server call) - instant-search callers filter
                    on every keystroke via handleSearch, so the button would be a
                    redundant no-op click for them and is left out. */}
                {isSearchClicked && (
                  <Button
                    variant="outline"
                    size="icon"
                    onClick={handleClickSearch}
                    disabled={disableButton && searchIniMount}
                    className="!h-10 !w-10"
                  >
                    <Search className="h-4 w-4" />
                  </Button>
                )}
              </div>
            )}
          </div>
        )}

        {/* Second Row - Pagination & Controls */}
        <div className='flex items-center justify-between gap-4 flex-wrap'>
          {/* Items Per Page & Downloads */}
          {!hideDocs && TotalRecords !== 0 && (
            <div className='flex items-center gap-2'>
              {TotalRecords > 25 && (
                <Select value={String(props.paginationSecondValue)} onValueChange={(value) => onChangeItemperpage({ target: { value } })}>
                  <SelectTrigger className="!w-[80px] !h-9" id='selectItems'>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="25">25</SelectItem>
                    <SelectItem value="50">50</SelectItem>
                    <SelectItem value="100">100</SelectItem>
                    <SelectItem value="200">200</SelectItem>
                    <SelectItem value="500">500</SelectItem>
                  </SelectContent>
                </Select>
              )}

              {!hideDocs && (
                <>
                  <Select
                    value={documentType}
                    onValueChange={setDocumentType}
                    disabled={masking}
                  >
                    <SelectTrigger className="!w-[80px] !h-9" id='selectFile'>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="PDF">PDF</SelectItem>
                      <SelectItem value="CSV">CSV</SelectItem>
                    </SelectContent>
                  </Select>

                  {documentType === "CSV" ? (
                    <Button
                      variant="outline"
                      size="icon"
                      disabled={masking}
                      asChild
                      className="!h-10 !w-10"
                    >
                      <CSVLink
                        data={props.csvData}
                        filename={`${props.csvFileName}.csv`}
                        target="_blank"
                        className="flex items-center justify-center"
                      >
                        <Download className="h-4 w-4" />
                      </CSVLink>
                    </Button>
                  ) : (
                    <Button
                      variant="outline"
                      size="icon"
                      disabled={masking}
                      onClick={() => props.exportPDF()}
                      className="!h-10 !w-10"
                    >
                      <Download className="h-4 w-4" />
                    </Button>
                  )}

                  {enableAll && (
                    <Button
                      variant="default"
                      size="sm"
                      onClick={() => downloadAllDocsHandler()}
                      disabled={masking || downloadAllLoader}
                      className="!h-9"
                    >
                      {downloadAllLoader && (
                        <span className="inline-block w-3 h-3 border-2 border-current border-t-transparent rounded-full animate-spin mr-2" />
                      )}
                      {downloadAllLoader ? "Preparing..." : (reportsLoader?.loader ? "Downloading..." : "Download All")}
                    </Button>
                  )}
                </>
              )}
            </div>
          )}

          {/* Total Amount Display */}
          {props.totalAmount && props.showAmount && (
            <div className='flex items-center gap-2'>
              <span className="text-sm font-semibold">{`Total (${Currency()}):`}</span>
              <Tooltips info={props.info} />
              <span className="text-sm font-semibold">{props.sumAmount}</span>
            </div>
          )}

          {/* Pagination Controls */}
          {props.data != undefined && pageValue > 1 && TotalRecords > 0 && (
            <Pagination className="mx-0">
              <PaginationContent>
                <PaginationItem>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => handlePageChange(1)}
                    disabled={props.paginationFirstValue === 1}
                    className="!h-10 !w-10"
                    id='firstPage'
                  >
                    <ChevronsLeft className="h-4 w-4" />
                  </Button>
                </PaginationItem>
                <PaginationItem>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => handlePageChange(props.paginationFirstValue - 1)}
                    disabled={props.paginationFirstValue === 1}
                    className="!h-10 !w-10"
                    id='prevPage'
                  >
                    <ChevronLeft className="h-4 w-4" />
                  </Button>
                </PaginationItem>
                {renderPaginationItems()}
                <PaginationItem>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => handlePageChange(props.paginationFirstValue + 1)}
                    disabled={props.paginationFirstValue === pageValue}
                    className="!h-10 !w-10"
                    id='nextPage'
                  >
                    <ChevronRight className="h-4 w-4" />
                  </Button>
                </PaginationItem>
                <PaginationItem>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => handlePageChange(pageValue)}
                    disabled={props.paginationFirstValue === pageValue}
                    className="!h-10 !w-10"
                    id='lastPage'
                  >
                    <ChevronsRight className="h-4 w-4" />
                  </Button>
                </PaginationItem>
              </PaginationContent>
            </Pagination>
          )}

          {/* Results Info & Manage Columns */}
          <div className='flex items-center gap-4 ml-auto'>
            <div className='flex items-center gap-2'>
              <span className='text-sm font-medium'>Results:</span>
              <span className='text-sm text-nowrap'>
                {isVisible && `${firstRecord} - ${secondRecord} of ${TotalRecords}`}
              </span>
              {props.reloadRequired && (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={reloadPage}
                  className="!h-10 !w-10"
                >
                  <RotateCw className="h-4 w-4" />
                </Button>
              )}
            </div>

            {allColumns.length > 0 && (
              <ColumnManager
                columns={allColumns}
                onToggle={toggleVisibility}
                onReorder={reorder}
                onReset={resetToDefault}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    resData: state.affiliateSlice.resData,

  }
}
export default connect(mapStateToProps)(Vpagination);